export default __webpack_public_path__ + "static/media/needles.9ac51c54.jpg";